(function() {
  const sections = document.querySelectorAll('.section-image-with-accordion');
  
  sections.forEach(section => {
    const accordionItems = section.querySelectorAll('.image-with-accordion-content-accordion-item');
    const images = section.querySelectorAll('.image-with-accordion-image');
    const accordionTitles = section.querySelectorAll('.image-with-accordion-content-accordion-item-title');
    
    let currentIndex = 0;
    let autoSwapInterval = null;

    // Function to switch to a specific accordion item
    function switchToIndex(index) {
      // Remove active class from all items and images
      accordionItems.forEach(item => item.classList.remove('active'));
      images.forEach(img => img.classList.remove('active'));
      
      // Add active class to selected items
      if (accordionItems[index]) accordionItems[index].classList.add('active');
      if (images[index]) images[index].classList.add('active');
      
      currentIndex = index;
    }

    // Add click handlers to accordion titles
    accordionTitles.forEach((title, index) => {
      title.addEventListener('click', () => {
        switchToIndex(index);
      });
    });

    // Auto-swap functionality
    if (section.dataset.autoSwap === 'true') {
      const interval = parseInt(section.dataset.swapInterval) * 1000 || 3000;

      function autoSwap() {
        const nextIndex = (currentIndex + 1) % accordionItems.length;
        switchToIndex(nextIndex);
      }

      // Start auto-swapping
      autoSwapInterval = setInterval(autoSwap, interval);

      // Pause on hover
      section.addEventListener('mouseenter', () => {
        if (autoSwapInterval) clearInterval(autoSwapInterval);
      });

      section.addEventListener('mouseleave', () => {
        if (autoSwapInterval) clearInterval(autoSwapInterval);
        autoSwapInterval = setInterval(autoSwap, interval);
      });
    }

    // Initialize first item as active
    switchToIndex(0);
  });
})();